import './App.css';
import Banar from './Components/Banar/Banar';
import Introduction from './Components/Introduction/Introduction';
import Navbar from './Components/Navbar/Navbar';
import Projects from './Components/Projects/Projects';
import TechStack from './Components/TechStack/TechStack';
import { useState, useEffect } from 'react';
import ReactGA from 'react-ga'
import ContactMe from './Components/ContactMe/ContactMe';
import Social from './Components/Social';
import Experience from './Components/Experience/Experience';

function App() {
  useEffect(()=>{
    ReactGA.initialize('UA-256323187-1');
ReactGA.pageview(window.location.pathname + window.location.search);
  },[])
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1850);
  }, []);
  return (
    <>
      {loading ? (
        <div className="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
      ) : (
        <>
        <Social/>
          <Navbar />
          <Banar />
          <div className="container">
            <Introduction />
            <Projects />
            <Experience/>
            <TechStack/>
          </div>
            <ContactMe/>
        </>
      )}
    </>

  );
}

export default App;
